require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-courier-mail-features-one-earle-lane-90-sold-before-completion.json") })
        }
      }, "path---journal-courier-mail-features-one-earle-lane-90-sold-before-completion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-courier-mail-features-one-earle-lane-90-sold-before-completion!./.cache/json/journal-courier-mail-features-one-earle-lane-90-sold-before-completion.json
// module id = 473
// module chunks = 231608221292675